import { useLocale } from "../i18n/useLocale.js";

export function MaterialStockSection({ collapsed, materialBaseName, children }) {
  const { display } = useLocale();
  const scopeNote = (
    <p className="material-stock-scope">
      {materialBaseName ? (
        <>
          {display.t("web.materialStock.scopeNoteBeforeMaterial")}{" "}
          <strong>{materialBaseName}</strong>
          {display.t("web.materialStock.scopeNoteAfterMaterial")}
        </>
      ) : (
        display.t("web.materialStock.scopeNote")
      )}
    </p>
  );

  if (!collapsed) {
    return (
      <div className="material-stock-section">
        {scopeNote}
        {children}
      </div>
    );
  }

  return (
    <details className="material-stock-section material-stock-section--collapsible">
      <summary>{display.t("web.materialStock.summaryCollapsed")}</summary>
      <div className="material-stock-section-body">
        {scopeNote}
        {children}
      </div>
    </details>
  );
}
